import { useState, useEffect } from "react"
import { Grid, Icon, IconButton } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { Select, Tooltip } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";
//Components
import { SidePanel, Button, ToggleSwitch } from "@gpstrackit/react-controls";

import {
    searchTagsRequest,
    searchDealersRequest,
    accountFiltersSearchRolesRequest,
    clearRedux,
} from "Redux/actions";

import { HasPermission } from 'Core/security'

const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, tableRef, selectedTags, setSelectedTags, setDealer, dealer, currentRoles, setRoles, selectStatusAccount, setSelectStatusAccount, statusOptions } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const tags = useSelector(state => state.generalRedux.tags);
    const loading = useSelector(state => state.generalRedux.tagLoading);
    const loadingAccounts = useSelector(state => state.commonRedux.loadingDataView);
    const user = useSelector(state => state.securityRedux.user);

    const { roles, roleLoading } = useSelector(state => state.advancedFiltersRedux)

    const {
        dealers,
        dealersLoading,
    } = useSelector(state => state.generalRedux);

    //Local States
    const [conditions, setConditions] = useState([]);
    const hasSelectedStatus = selectStatusAccount?.length > 0;

    const handleApply = () => {
        tableRef?.current?.getData({ newConditions: conditions });
    }

    const deletionHandler = () => {
        tableRef?.current?.conditionsHandler([]);
        tableRef?.current?.getData({ newConditions: [] });
        setSelectedTags([]);
    }

    useEffect(() => {
        if (openPanel) {
            dispatch(searchTagsRequest({ messages: messages }));
            dealers && dealers.length === 0 && dispatch(searchDealersRequest());
            if (dealer) dispatch(accountFiltersSearchRolesRequest(dealer));
        }
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([]);
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(dealer || currentRoles || hasSelectedStatus || selectedTags?.length > 0) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Tooltip title={messages['accounts_main_remove_filters']}>
                        <IconButton
                            onClick={() => {
                                setSelectedTags([]);
                                setDealer(null);
                                setRoles(null);
                                setSelectStatusAccount([]);

                                let currentConditions = conditions;

                                let deleteTags = currentConditions.findIndex((item) => item.fields[0] === 'tagIds');
                                deleteTags >= 0 && currentConditions.splice(deleteTags, 1);

                                let deleteStatus = currentConditions.findIndex((item) => item.fields[0] === 'status');
                                deleteStatus >= 0 && currentConditions.splice(deleteStatus, 1);

                                let deletedealer = currentConditions.findIndex((item) => item.fields[0] === 'dealerId');
                                deletedealer >= 0 && currentConditions.splice(deletedealer, 1);

                                let deleteRole = currentConditions.findIndex((item) => item.fields[0] === 'roleId');
                                deleteRole >= 0 && currentConditions.splice(deleteRole, 1);

                                setConditions(currentConditions);

                                tableRef?.current?.getData({ newConditions: currentConditions });

                            }}
                            size="large">
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>

                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingAccounts}
                    >
                        {messages['accounts_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <Select
                        id="dealer-selector"
                        label={messages['accounts_main_dealer']}
                        value={dealers ? dealers.filter((item, index) => item.id === dealer) : []}
                        onChange={(item = []) => {
                            let currentConditions = conditions;
                            let deleteItem = currentConditions.findIndex((item) => item.fields[0] === 'dealerId');
                            deleteItem >= 0 && currentConditions.splice(deleteItem, 1);

                            setDealer(item?.id);
                            dispatch(clearRedux("ACCOUNTS_ADVANCED_FILTERS", { roles: [] }))
                            item && dispatch(accountFiltersSearchRolesRequest(item?.id));

                            if (item) currentConditions.push({ fields: ["dealerId"], terms: [item?.id], exact: true, conditionOperator: "AND" })

                            let deleteRoles = currentConditions.findIndex((item) => item.fields[0] === 'roleId');
                            deleteRoles >= 0 && currentConditions.splice(deleteRoles, 1);

                            setRoles(null);
                            setConditions(currentConditions);
                        }}
                        options={dealers}
                        textField="name"
                        valueField="id"
                        loading={dealersLoading}
                        isClearable
                        placeholder={messages['select']}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, marginBottom: 5 }}>
                    <Select
                        id="tags-selector"
                        label={messages['accounts_main_tags']}
                        value={selectedTags?.length ? tags.filter((item) => selectedTags.find(x => x === item.id)) : []}
                        onChange={(item = []) => {

                            let currentConditions = conditions;

                            let deleteItem = currentConditions.findIndex((item) => item.fields[0] === 'tagIds');
                            deleteItem >= 0 && currentConditions.splice(deleteItem, 1);
                            let itemsTags = []
                            if (item && item.length > 0 && item.find(x => x.id === -1))
                                itemsTags = tags.filter(x => x.id === -1);
                            else
                                itemsTags = item;

                            setSelectedTags(itemsTags?.map(x => x.id))
                            if (itemsTags) currentConditions.push({ fields: ["tagIds"], terms: itemsTags.map(x => x.id), exact: true, conditionOperator: "AND" })

                            setConditions(currentConditions);
                        }}
                        options={tags}
                        textField="label"
                        valueField="id"
                        loading={loading}
                        isClearable
                        placeholder={messages['select']}
                        multiple
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, marginBottom: 5 }}>
                    <Select
                        id="accounts-selector"
                        label={messages['accounts_main_status_filter']}
                        value={selectStatusAccount?.length ? statusOptions.filter((item) => selectStatusAccount.find(x => x === item.id)) : []}
                        onChange={(item = []) => {
                            let currentConditions = conditions;

                            let deleteItem = currentConditions.findIndex((item) => item.fields[0] === 'status');
                            deleteItem >= 0 && currentConditions.splice(deleteItem, 1);
                            let itemStatus = []
                            if (item && item.length > 0 && item.find(x => x.id === -1))
                                itemStatus = selectStatusAccount.filter(x => x.id === -1);
                            else
                                itemStatus = item;
                            setSelectStatusAccount(itemStatus?.map(x => x.id))
                            if (itemStatus) currentConditions.push({ fields: ["status"], terms: itemStatus.map(x => x.id), exact: true, conditionOperator: "AND" })
                            setConditions(currentConditions);
                        }}
                        options={statusOptions}
                        textField="label"
                        valueField="id"
                        loading={loading}
                        isClearable
                        placeholder={messages['select']}
                        multiple
                    />
                </Grid>
            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters